export default "__VITE_PUBLIC_ASSET__272a8fc1__"